module.exports = __webpack_public_path__ + "img/logo-light.db4485fc.svg";